import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0ccdd8c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "address-list"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 保存 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_Switch = _resolveComponent("Switch");
  const _component_van_button = _resolveComponent("van-button");
  const _component_Form = _resolveComponent("Form");
  const _component_MdAddressPicker = _resolveComponent("MdAddressPicker");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Form, {
    modelValue: $data.from,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.from = $event),
    onSubmit: $options.onSubmit,
    "label-width": "2.1rem"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.from.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.from.name = $event),
        name: "name",
        label: "收货人",
        placeholder: "填写收货人姓名"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.from.mobile,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.from.mobile = $event),
        name: "mobile",
        label: "手机号",
        type: "tel",
        placeholder: "填写手机号"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        class: "quhao",
        "is-link": "",
        readonly: "",
        name: "code_posi",
        "input-align": "right",
        modelValue: $data.from.code_posi,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.from.code_posi = $event),
        placeholder: "中国大陆 +86",
        onClick: _cache[3] || (_cache[3] = $event => $data.quhao = true)
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: $data.quhao,
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: $data.payList,
          onConfirm: $options.onConfirmquhao,
          onCancel: _cache[4] || (_cache[4] = $event => $data.quhao = false)
        }, null, 8, ["columns", "onConfirm"])]),
        _: 1
      }, 8, ["show"])]),
      _: 1
    }), $data.provinceEnabled ? (_openBlock(), _createBlock(_component_van_cell_group, {
      key: 0
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        "is-link": "",
        name: "area",
        modelValue: $data.from.area,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.from.area = $event),
        readonly: "",
        label: "所在地区",
        type: "textarea",
        rows: "1",
        autosize: "true",
        placeholder: "省/市/区",
        onClick: $options.handleShowProvincePivker
      }, null, 8, ["modelValue", "onClick"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.from.address_detail,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.from.address_detail = $event),
        autosize: "",
        name: "address_detail",
        label: "详细地址",
        rows: "1",
        type: "textarea",
        placeholder: "填写详细地址和门牌号"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.from.postal_code,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.from.postal_code = $event),
        name: "postal_code",
        type: "digit",
        label: "邮政编码",
        placeholder: "填写邮政编码"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), !$setup.orderId || $setup.orderId == 'null' ? (_openBlock(), _createBlock(_component_van_cell_group, {
      key: 1,
      class: "is_default"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        name: "is_default",
        label: "设为默认地址",
        "label-width": "2.5rem"
      }, {
        input: _withCtx(() => [_createVNode(_component_Switch, {
          modelValue: $data.from.is_default,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.from.is_default = $event),
          "active-color": "#00C4A1",
          "inactive-color": "#EDEDED",
          size: "27px"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_van_button, {
      class: _normalizeClass(["frombtn", {
        gray: $options.save_btn_enabled == false
      }]),
      round: "",
      block: "",
      type: "primary",
      "native-type": "submit"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }, 8, ["class"])]),
    _: 1
  }, 8, ["modelValue", "onSubmit"]), $data.showProvincePicker ? (_openBlock(), _createBlock(_component_MdAddressPicker, {
    key: 0,
    title: _ctx.请选择所在地区,
    counrty_code: $data.from.country_code,
    total_list: $data.areaList,
    index_list: $data.selectedProvinceList,
    onHandleClosePicker: $options.handleCloseProvincePicker,
    onHandleConfirmPicker: $options.handleConfirmProvincePicker
  }, null, 8, ["title", "counrty_code", "total_list", "index_list", "onHandleClosePicker", "onHandleConfirmPicker"])) : _createCommentVNode("", true)]);
}